import React, {useEffect} from 'react'
import { backgroundColorCounter } from '../style'
import $ from 'jquery';
import { useTranslation  } from 'react-i18next';

const Counters = () => {
  const { t } = useTranslation();
  useEffect(
    () => {    
      var count = 0;
      if ($('.knsl-counters-card').length) {
        $(window).scroll(function() {
            if($('.knsl-counters-card').offset()!==undefined){
                var oTop = $('.knsl-counters-card').offset().top - window.innerHeight;
                if (count === 0 && $(window).scrollTop() > oTop) {
                    $('.knsl-counter-number').each(function() {
                    var $this = $(this),
                        countTo = $this.attr('data-count');
                    $({
                        countNum: $this.text()
                    }).animate({
                        countNum: countTo
                    }, {
                        duration: 3000,
                        easing: 'swing',
                        step: function() {
                        $this.text(Math.floor(this.countNum));
                        },
                        complete: function() {
                        $this.text(this.countNum);
                        }
                    });
                    });
                    count = 1;
                }
            }
        });
      }
      return () => { $(window).scroll(function() {}) }
     }
    );

    return (
        <section className="knsl-p-0-100" style={backgroundColorCounter}>
          <img src="img/palm.svg" className="knsl-deco-right" alt="palm" />
          <div className="container">

            {/* <!-- features card --> */}
            <div className="knsl-features-card knsl-counters-card knsl-scroll-animation">

              <div className="row">
                <div className="col-6 col-lg-3">

                  {/* <!-- icon box --> */}
                  <div className="knsl-icon-box">
                    <div className="knsl-counter-number knsl-mb-10" data-count="1"></div>
                    <h5>{t('main.hotel')}</h5>
                  </div>
                  {/* <!-- icon box end --> */}

                </div>
                <div className="col-6 col-lg-3">

                  {/* <!-- icon box --> */}
                  <div className="knsl-icon-box">
                    <div className="knsl-counter-number knsl-mb-10" data-count="10"></div>
                    <h5>{t('main.rooms')}</h5>
                  </div>
                  {/* <!-- icon box end --> */}

                </div>
                <div className="col-6 col-lg-3">

                  {/* <!-- icon box --> */}
                  <div className="knsl-icon-box">
                    <div className="knsl-counter-number knsl-mb-10" data-count="6"></div>
                    <h5>{t('main.yards')}</h5>
                  </div>
                  {/* <!-- icon box end --> */}

                </div>
                <div className="col-6 col-lg-3">

                  {/* <!-- icon box --> */}
                  <div className="knsl-icon-box">
                    <div className="knsl-counter-number knsl-mb-10" data-count="653"></div>
                    <h5>{t('main.guests')}</h5>
                  </div>
                  {/* <!-- icon box end --> */}

                </div>
              </div>

            </div>
            {/* <!-- features card end --> */}

          </div>
        </section>
    )
}

export default Counters